import { ModuleWithProviders, NgModule } from '@angular/core';
import { BaseReportService } from './base-report.service';
import { ReferralReportService } from './referral-report.service';
import { ReportHelper } from './report-helper';
import { SystemReportService } from './system-report.service';
import { ReportExtractService } from './report-extract.service';
import { ReportDashboardService } from './report-dashboard.service';

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
  providers: [],
})
export class ReportingModule {
  static forRoot(): ModuleWithProviders<ReportingModule> {
    return {
      ngModule: ReportingModule,
      providers: [
        ReportHelper,
        BaseReportService,
        ReferralReportService,
        SystemReportService,
        ReportExtractService,
        ReportDashboardService,
      ],
    };
  }
}
